var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common-header container clearfix"},[_c('div',{staticClass:"logo"}),_c('div',{staticClass:"title",attrs:{"title":_vm.title}},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }